import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
//import Paper from '@material-ui/core/Paper';
import { post } from '../../../modules/utility';
//import Grid from '@material-ui/core/Grid';
import { getGlobalClasses } from '../../../themes';
import AuthUserContainer from '../../../containers/AuthUser';

import moment from 'moment';
import DurationCountdown from '../../../components/DurationCountdown';

import TimeClockIcon from '../../../images/icons/timeClockMobile.svg';
import GreenChecked from '../../../images/icons/greenChecked.svg';
import WarningIconSvg from '../../../images/icons/warningIcon.svg';
import OrangeRightArrow from '../../../images/icons/orangeRightArrow.svg';
import { Paper } from '@material-ui/core';

//const stlBlue = '#1289d4';
const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		timeClockContainer: {
			margin: '2vw 0',
			padding: '4vw',
			borderRadius: '1vw',
			backgroundColor: '#fff',
		},
		contentTitle: {
			display: 'flex',
			alignItems: 'center',
			fontSize: '160%',
			paddingBottom: '2vw',
			fontWeight: '800',
		},
		timeClockIcon: {
			display: 'inline-block',
			width: '5vw',
			height: '5vw',
			backgroundImage: `url('${TimeClockIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: '1vw',
			marginLeft: 0,
		},
		runningSearch: {
			paddingLeft: '.5vw',
			display: 'inline',
			alignItems: 'center',
			color: '#666',
		},
		greenCheckedIcon: {
			display: 'inline-block',
			width: '4vw',
			height: '4vw',
			backgroundImage: `url('${GreenChecked}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: '1vw',
			marginTop: '-1vw',
			marginLeft: '1vw',
		},
		smallWarningIcon: {
			display: 'inline-block',
			width: '9vw',
			height: '6vw',
			backgroundImage: `url('${WarningIconSvg}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: '1vw',
			marginLeft: 0,
			marginTop: 0,
		},
		orangeRightArrow: {
			display: 'inline-block',
			width: '6vw',
			height: '6vw',
			backgroundImage: `url('${OrangeRightArrow}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginLeft: '1vw',
		},
		timeClockRule: {
			display: 'flex',
			fontSize: '140%',
		},
		currentStatusTitle: {
			fontSize: '130%',
			// letterSpacing: 1,
			color: '#333',
			marginTop: '1vw',
			marginBottom: '.5vw',
		},
		currentStatusDetails: {
			lineHeight: 1.4,
			marginBottom: 5,
		},
		statusValue: {
			fontWeight: 600,
		},
		durationToWaitFor10Hours: {
			fontSize: '120%',
			fontWeight: 700,
		},
		infoSection: {
			display: 'flex',
			flexDirection: 'row',
			fontSize: '130%',
		},
		detailSection: {},
	};
};

class TimeClockSection extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		this.getShiftAnalysis({ callback: _.noop });
	}

	formatDurationToMinutes = (d) => {
		return moment.duration(d).format('d [days], h [hours], m [minutes]');
	};

	getShiftAnalysis = ({ callback }) => {
		const { showErrors } = this.props;
		post({
			method: 'timeClockShift.user.getShiftAnalysis',
			params: {},
			callback: (err, r) => {
				if (err) {
					showErrors(err);
					return callback(err);
				}

				const timeClockAnalysisResult = _.get(r, 'timeClockAnalysisResults.0', {});
				this.setState({
					timeClockAnalysisResult,
				});
				callback(null, { timeClockAnalysisResult });
			},
		});
	};

	render() {
		//const { authUser } = this.props;
		const { classes } = this.props;
		const { timeClockAnalysisResult } = this.state;

		if (_.isUndefined(timeClockAnalysisResult)) {
			return <div className={classes.globalFetching}>Fetching time clock info...</div>;
		}

		const {
			isCurrentlyClockedIn,
			isCurrentlyClockedOut,
			dateTimeOfLastClockIn,
			dateTimeOfLastClockOut,
			isLessThan10HoursFromLastShift,

			//lastShift, currentShift,

			hasWorkedOver80HoursSinceLastReset,
			last34HourResetDateTime,
			secondsWorkedSinceLast34HourReset,

			doNotShow34HourRule,
			hasOpenTickets,
			canNotClockInReason,
			shiftWarningText,
		} = timeClockAnalysisResult;

		let durationSinceLastShift = moment.duration(moment().diff(moment(dateTimeOfLastClockOut)));
		let durationClockedIn = moment.duration(moment().diff(moment(dateTimeOfLastClockIn)));
		if (durationClockedIn === -1) {
			durationClockedIn = 0;
		}

		if (durationSinceLastShift === -1) {
			durationSinceLastShift = 0;
		}

		let hoursSinceLast34HourReset = '-';
		let thirtyFourHoursAfterClockOut;
		if (secondsWorkedSinceLast34HourReset) {
			hoursSinceLast34HourReset = moment
				.duration(secondsWorkedSinceLast34HourReset, 'seconds')
				.format('h [hrs]', 2);
			const clockOutMoment = moment(dateTimeOfLastClockOut);
			thirtyFourHoursAfterClockOut = moment(clockOutMoment).add(34, 'hours');
		}

		return (
			<Paper>
				<div className={classes.timeClockContainer}>
					<div className={classes.contentTitle}>
						<div className={classes.timeClockIcon} />
						<div>Time Clock Info</div>
					</div>

					<div className={classes.detailSection}>
						{isCurrentlyClockedOut && (
							<div>
								<div className={classes.infoSection}>
									{!isLessThan10HoursFromLastShift && <div className={classes.greenCheckedIcon} />}
									{isLessThan10HoursFromLastShift && <div className={classes.smallWarningIcon} />}
									<div>
										<div>
											<span>Time since last shift : </span>
											<span>{this.formatDurationToMinutes(durationSinceLastShift)}</span>
										</div>
										<div>
											<span>Last shift end date &amp; time : </span>
											<span className={classes.statusValue}>
												{moment(dateTimeOfLastClockOut).format('M/D h:mm a')}
											</span>
										</div>
									</div>
								</div>

								{!doNotShow34HourRule && (
									<div className={classes.infoSection}>
										{!hasWorkedOver80HoursSinceLastReset && (
											<div className={classes.greenCheckedIcon} />
										)}
										{hasWorkedOver80HoursSinceLastReset && (
											<div className={classes.smallWarningIcon} />
										)}
										<div>
											<div>
												<span>Hours worked since last 34 hour reset : </span>
												<span className={classes.statusValue}>{hoursSinceLast34HourReset}</span>
											</div>
											<div>
												<span>Last 34 hour reset date and time : </span>
												<span className={classes.statusValue}>
													{moment(last34HourResetDateTime).format('M/D h:mm a')}
												</span>
											</div>

											{hasWorkedOver80HoursSinceLastReset && (
												<div>
													Time to wait until you can clock in to clear 34 hours reset requirement.
													<div className={classes.durationToWaitFor10Hours}>
														<DurationCountdown
															startMoment={thirtyFourHoursAfterClockOut}
															handleCountdownDone={this.handleCountdownDone}
														/>
													</div>
												</div>
											)}
										</div>
									</div>
								)}
							</div>
						)}

						{hasOpenTickets && (
							<div className={classes.infoSection}>
								<div className={classes.smallWarningIcon} />
								<div>
									You have an open incident report. Please fill out this report before you clock
									out.
								</div>
							</div>
						)}

						{canNotClockInReason && (
							<div className={classes.infoSection}>
								<div className={classes.smallWarningIcon} />
								<div>{canNotClockInReason}</div>
							</div>
						)}

						{shiftWarningText && (
							<div className={classes.infoSection}>
								<div className={classes.smallWarningIcon} />
								<div>{shiftWarningText}</div>
							</div>
						)}

						{isCurrentlyClockedIn && (
							<div style={{ marginLeft: '1vw' }}>
								<div className={classes.timeClockRule}>
									<div>
										<div className={classes.currentStatusTitle}>
											<span>Clocked In</span>
											<div className={classes.greenCheckedIcon} />
										</div>
										<div className={classes.currentStatusDetails}>
											<div>
												<span>Clocked in for: </span>
												<span className={classes.statusValue}>
													{this.formatDurationToMinutes(durationClockedIn)}
												</span>
											</div>
											<div>
												<span>Clocked in at: </span>
												<span className={classes.statusValue}>
													{moment(dateTimeOfLastClockIn).format('M/D h:mm a')}
												</span>
											</div>
										</div>
									</div>
								</div>
								<div className={classes.timeClockRule}></div>
							</div>
						)}
					</div>
				</div>
			</Paper>
		);
	}
}

TimeClockSection.propTypes = {
	authUser: PropTypes.object,
};
export default _.flow([withStyles(styles), AuthUserContainer])(TimeClockSection);
